import DatePicker from 'components/form/DatePicker/styled';

export default DatePicker;
